(() => {
  if (window.plRecentViewInitialized) return;
  window.plRecentViewInitialized = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pl-recent-view]');
    if (!button) return;

    const section = button.closest('.pl-recent');
    const grid = section?.querySelector('[data-pl-recent-grid]');
    if (!grid) return;

    const columns = button.dataset.plRecentView;
    const isMobile = Boolean(button.closest('.pl-recent__mobile-view'));
    if (isMobile ? columns !== '1' && columns !== '2' : columns !== '2' && columns !== '3' && columns !== '4') return;

    if (isMobile) grid.dataset.plRecentColumns = columns;
    else grid.dataset.plRecentDesktopColumns = columns;
    button.parentElement.querySelectorAll('[data-pl-recent-view]').forEach((option) => {
      const active = option.dataset.plRecentView === columns;
      option.classList.toggle('is--active', active);
      option.setAttribute('aria-pressed', String(active));
    });
  });
})();
